import axios from "../axios";

class RAPSRelatedDataHandler {
  static async getCountries() {
    try {
      const response = await axios.get("ikamet/get-countries-for-dropdown");
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getBirthCountries() {
    try {
      const response = await axios.get(
        "ikamet/get-birth-countries-for-dropdown"
      );
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getIncomeTypes() {
    try {
      const response = await axios.get("ikamet/get-income-types-for-dropdown");
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getProfessions() {
    try {
      const response = await axios.get(
        "ikamet/get-professions-list-for-dropdown"
      );
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getResidenceReasons() {
    try {
      const response = await axios.get(
        "ikamet/get-residence-reasons-for-dropdown"
      );
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getInsuranceTypes() {
    try {
      const response = await axios.get(
        "ikamet/get-insurance-types-for-dropdown"
      );
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getTimeUnits() {
    try {
      const response = await axios.get(
        "ikamet/get-time-units-list-for-dropdown"
      );
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getMaritalStatuses() {
    try {
      const response = await axios.get(
        "ikamet/get-marital-statuses-for-dropdown"
      );
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getPassportTypes() {
    try {
      const response = await axios.get("ikamet/get-passport-types");
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }

  /** address related **/
  static async getProvinces() {
    try {
      const response = await axios.get("ikamet/get-provinces-for-dropdown");
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.order,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getRegions(province) {
    try {
      const response = await axios.get("ikamet/get-regions-for-dropdown", {
        params: {
          province: province,
        },
      });
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getNeighbourhoods(region) {
    try {
      const response = await axios.get(
        "ikamet/get-neighbourhoods-for-dropdown",
        {
          params: {
            region: region,
          },
        }
      );
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getStreets(neighbourhood) {
    try {
      const response = await axios.get("ikamet/get-streets-for-dropdown", {
        params: {
          neighbourhood: neighbourhood,
        },
      });
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getBuildings(neighbourhood, street) {
    try {
      const response = await axios.get("ikamet/get-buildings-for-dropdown", {
        params: { neighbourhood: neighbourhood, street: street },
      });
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getApartments(neighbourhood, building) {
    try {
      const response = await axios.get("ikamet/get-apartments-for-dropdown", {
        params: {
          neighbourhood: neighbourhood,
          building: building,
        },
      });
      const dropdownGet = response.data.data;
      const dropdownSet = {};
      dropdownGet.forEach((item) => {
        dropdownSet["item" + item.value] = {
          label: item.label,
          id: item.id,
          value: item.value,
        };
      });
      return {
        get: dropdownGet,
        set: dropdownSet,
      };
    } catch (error) {
      throw error;
    }
  }
  static async getFullAddress(apartment) {
    try {
      const response = await axios.get("ikamet/get-full-address-for-dropdown", {
        params: {
          apartment: apartment,
        },
      });
      const result = response.data.data;
      return result.acikAdres;
    } catch (error) {
      throw error;
    }
  }
}

export default RAPSRelatedDataHandler;
